export const AuditRecommendationStateList = ["presented", "favorite"] as const;

export type AuditRecommendationState =
  (typeof AuditRecommendationStateList)[number];
